function getIndividual(name) {
  let individuals = require('./Individual.json');

  if (individuals[name]) {
    return individuals[name];
  }

  return {
    name: 'Person Not Found',
    role: '',
    paragraph1: '',
    paragraph2: '',
  };
}

export { getIndividual };